import React from 'react'
import PropTypes from 'prop-types'
import styles from './index.module.scss'

function Overview({ title, value }) {
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.value}>{value}</h3>
      <span>
        <strong>{title}</strong>
      </span>
    </div>
  )
}

Overview.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
}

export default Overview
